// @flow

import React, { type Node } from 'react';

import { PixPendingPage } from '@tectonics/look-and-feel/uber-v2/page-payment-pending/payment-method/pix';
import { PixPispPendingPage } from '@tectonics/look-and-feel/uber-v2/page-payment-pending/payment-method/pix-pisp';
import { usePendingIncomingPayment, getSafePaymentTypeCode } from '@tectonics/prs/incoming-payment';

export function PaymentMethodResolver(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const paymentMethodCode = getSafePaymentTypeCode(incomingPayment);

  switch (paymentMethodCode) {
    case 'pix':
      return <PixPendingPage />;
    case 'pix-pisp':
      return <PixPispPendingPage />;
    default:
      throw new Error(`Payment method "${paymentMethodCode}" has no implemented page for Uber-V2`);
  }
}
